export const skipSearchParams = (skip?: string | null): number | null => {
	if (typeof skip === 'string' && skip.length > 0 && +skip > 0) {
		return +skip
	}
	return null
}
